import RadioGroup from '@mui/material/RadioGroup';
import { Stack } from '@talentmesh/core';
import React from 'react';
import useTMTranslation from '../../../../Hooks/useTMTranslation';
import Body1Typography from '../Components/Body1Typography';
import TMRadio from '../Components/TMRadio';
import { useJobExperienceListContext } from './JobExperienceListContext';

interface JobExperienceListHeaderProps {
    onChange: (value: boolean) => void;
}

const JobExperienceListHeader = ({ onChange }: JobExperienceListHeaderProps) => {
    const { hasExperience } = useJobExperienceListContext();
    const { tCommon: t } = useTMTranslation();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value === 'true';
        onChange(value);
    };

    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack>
                <Body1Typography>{t('DoYouHaveJobExperience')}</Body1Typography>
                <RadioGroup row value={hasExperience} onChange={handleChange}>
                    <TMRadio data-cy="experienceYes" value="true" label={t('Yes')} />
                    <TMRadio data-cy="experienceNo" value="false" label={t('No')} />
                </RadioGroup>
            </Stack>
        </Stack>
    );
};

export default JobExperienceListHeader;
